export interface CreateRedirectLinkProps {
  applyLink: string;
  params: Record<string, unknown>;
}

export const createRedirectLink = ({
  applyLink,
  params,
}: CreateRedirectLinkProps) => {
  const url = new URL(
    `${window.location.origin}/pers-rec-results/api/redirect-handler`
  );
  const updatedParams = {
    ...params,
    destination_url: applyLink,
  };
  Object.entries(updatedParams).forEach(([key, value]) => {
    const stringValue: string =
      value === undefined ? 'undefined' : value?.toString();
    url.searchParams.append(key, stringValue);
  });

  return url.toString();
};
